import { Col, Image } from 'antd'
import React from 'react'
import logo1 from '../../images/logo1.png'
import miniLogo from '../../images/miniLogo.svg'

const LogoComponent = () => {
    return (
        <Col>
        <Col lg={{span:12}} xs={{span:0}}>
        <Image src={logo1}  width={192} preview={false}></Image>
        </Col>
        <Col lg={{span:0}}>
            <Image src={miniLogo} width={96} height={64} preview={false}></Image>
        </Col>
        </Col>
    )
}

export default LogoComponent
